import { css } from 'styled-components';
export const commonTheme = {
    base: css `
    --animation-duration: 1200ms;
  `,
    tiny: css `
    width: 0.875rem;
    height: 0.875rem;
  `,
    small: css `
    width: 1.3125rem;
    height: 1.3125rem;
  `,
    medium: css `
    width: 1.875rem;
    height: 1.875rem;
  `,
    big: css `
    height: 6.25rem;
    width: 6.25rem;
  `,
};
//# sourceMappingURL=common-theme.js.map